module.exports = __webpack_public_path__ + "static/bg.86cf5d57.png";